(function () {
  class BGTrailContainer extends PIXI.Container {
    constructor() {
      super();

      this._currentLevel = -1;
      this._maxLevel = 4;
      this._tweens = {};
      this._incrementTrailFinished = false;
      this._upgradeMinMultiplierFinished = false;
      // this._awardingMultiplier = false;
      this._multiplier = 1;

      this._moveTweenInfo = {};
      this._scaleTweenInfo = {};

      this._moveTweenInfos = [];
      this._scaleTweenInfos = [];

      this._minMultipliers = [2, 5, 10, 15, 20, 25, 50, 100];
      this._currentMinMultiplierLevel = 0;

      this._startingLevel = -1;
      this._eggAwardTextScaleContainerMasterScale = 0.8;

      this._jackSwayAnimFinished = false;
      this.jackAnimPromise = null;
      this.jackAnimResolver = null;

      this._lozLandscapeCoords = [];
      this._lozPortraitCoords = [];
      this._lozOn = [];
      this._lozOff = [];
      this._eggWobbleAnimPlaying = false;
    }

    isFull() {
      let result = false;
      if (this._currentLevel >= this._maxLevel - 1) {
        result = true;
      }
      return result;
    }

    hasPrizeBeenAwarded() {
      let result = false;

      if (this._eggMultiplierAwarded || this._eggFSAwarded) {
        result = true;
      }

      return result;
    }

    initialise() {
      messageBus.subscribe('spinner:GameConfigEvent', () => {
        this.onLayoutComplete();
      });

      Reflex.registerEventHandler('orientationChange', (isLandscape) => {
        this.onOrientationChange(isLandscape);
      });
    }

    // these functions are here, because originally
    // jack was parented to this class / obj
    // since then, jack has been moved, so he appears over the big win anim
    async moveJacksSpineAnimContainerOn() {
      this.jackSpineAnim.visible = false;
      this.jackStatic.visible = true;
      this.jackSpineAnimContainer.visible = true;
      this.jackSpineAnimContainer.x = -120;
      await game.tweenFromToAsync(
        this.jackSpineAnimContainer,
        {
          x: -120,
        },
        {
          x: 0,
          duration: 0.15,
          ease: 'power1.out',
        }
      );
    }

    async moveJacksSpineAnimContainerOff() {
      await game.tweenFromToAsync(
        this.jackSpineAnimContainer,
        {
          x: 0,
        },
        {
          x: -120,
          duration: 0.15,
          ease: 'none',
        }
      );
      this.jackSpineAnimContainer.visible = false;
    }

    async playJackEntranceAnim() {
      let jackEntranceAnimResolver = null;
      const jackEntranceAnimPromise = new Promise((resolve) => {
        jackEntranceAnimResolver = resolve;
      });

      this.jackSpineAnim.visible = true;
      this.jackStatic.visible = false;

      this.jackSpineAnim.spineObject.state.clearListeners();
      this.jackSpineAnim.play('Entrance', false, 0, null, null, () => {
        jackEntranceAnimResolver();
      });

      await jackEntranceAnimPromise;

      this.playJackIdleAnim();
    }

    async playJackBigWinAnim() {
      // are we already playing an anim?
      if (this.jackAnimResolver !== null) {
        // console.log('jack::anim already playing, resolve promise and ignore idle anim after');
        this.ignoreJackPlayIdle = true;
        this.jackAnimResolver();
        await this.jackAnimPromise;
        this.jackAnimResolver = null;
      }

      // create new promise - any existing one should be all done now
      this.jackAnimPromise = new Promise((resolve) => {
        this.jackAnimResolver = resolve;
      });

      // console.log('jack::playing Big_Win');
      this.jackSpineAnim.spineObject.state.clearListeners();
      this.jackSpineAnim.play('Big_Win', false, 0, null, null, (entry) => {
        if (entry && entry.animation && entry.animation.name === 'Big_Win') {
          // console.log('jack::Big_Win finished');
          this.ignoreJackPlayIdle = false;
          this.jackAnimResolver();
          this.jackSpineAnim.spineObject.state.clearListeners();
        } else {
          // anim has finished but not for us!
          // console.log('jack::Big_Win finished but not for us');
        }
      });

      await this.jackAnimPromise;
      this.jackAnimResolver = null;

      if (!this.ignoreJackPlayIdle) {
        this.playJackIdleAnim();
      } else {
        // console.log('jack::idle anim ignored');
        this.ignoreJackPlayIdle = false;
      }
    }

    async playJackNormalWinAnim() {
      // are we already playing an anim?
      if (this.jackAnimResolver !== null) {
        // console.log('jack::anim already playing, resolve promise and ignore idle anim after');
        this.ignoreJackPlayIdle = true;
        this.jackAnimResolver();
        await this.jackAnimPromise;
        this.jackAnimResolver = null;
      }

      // create new promise - any existing one should be all done now
      this.jackAnimPromise = new Promise((resolve) => {
        this.jackAnimResolver = resolve;
      });

      // console.log('jack::playing Normal_Win');
      this.jackSpineAnim.spineObject.state.clearListeners();
      this.jackSpineAnim.play('Normal_Win', false, 0, null, null, (entry) => {
        if (entry && entry.animation && entry.animation.name === 'Normal_Win') {
          // console.log('jack::Normal_Win finished');
          this.ignoreJackPlayIdle = false;
          this.jackAnimResolver();
          this.jackSpineAnim.spineObject.state.clearListeners();
        } else {
          // anim has finished but not for us!
          // console.log('jack::Normal_Win finished but not for us');
        }
      });

      await this.jackAnimPromise;
      this.jackAnimResolver = null;

      if (!this.ignoreJackPlayIdle) {
        this.playJackIdleAnim();
      } else {
        // console.log('jack::idle anim ignored');
        this.ignoreJackPlayIdle = false;
      }
    }

    // shouldnt worry about this as it has its own state
    async playJackSwayWinAnim() {
      this._jackSwayAnimFinished = false;

      // are we already playing an anim?
      if (this.jackAnimResolver !== null) {
        // console.log('jack::anim already playing, resolve promise and ignore idle anim after');
        this.ignoreJackPlayIdle = true;
        this.jackAnimResolver();
        await this.jackAnimPromise;
        this.jackAnimResolver = null;
      }

      // create new promise - any existing one should be all done now
      this.jackAnimPromise = new Promise((resolve) => {
        this.jackAnimResolver = resolve;
      });

      // console.log('jack::playing Sway');
      this.jackSpineAnim.spineObject.state.clearListeners();
      this.jackSpineAnim.play('Sway', false, 0, null, null, (entry) => {
        if (entry && entry.animation && entry.animation.name === 'Sway') {
          // console.log('jack::Sway finished');
          this.ignoreJackPlayIdle = false;
          this.jackAnimResolver();
          this.jackSpineAnim.spineObject.state.clearListeners();
        } else {
          // anim has finished but not for us!
          // console.log('jack::Sway finished but not for us');
        }
      });

      await this.jackAnimPromise;
      this.jackAnimResolver = null;

      if (!this.ignoreJackPlayIdle) {
        this.playJackIdleAnim();
      } else {
        // console.log('jack::idle anim ignored');
        this.ignoreJackPlayIdle = false;
      }

      this._jackSwayAnimFinished = true;
    }

    hasJackSwayAnimFinished() {
      return this._jackSwayAnimFinished;
    }

    playJackIdleAnim() {
      // console.log('jack::playing Idle');
      this.jackSpineAnim.spineObject.state.clearListeners();
      this.jackSpineAnim.play('Idle', true, 0, null, null, null);
    }

    stopJackAnim() {
      this.jackSpineAnim.stop();
    }

    async doJacksEntranceAnim() {
      await this.moveJacksSpineAnimContainerOn();
      await this.playJackEntranceAnim();
    }

    async doJacksExitAnim() {
      // turn off for now
      this.playJackEntranceAnim();
      await timerManager.delayAsync(200);
      await this.moveJacksSpineAnimContainerOff();

      this.stopJackAnim();
      this.jackSpineAnim.visible = false;
      this.jackStatic.visible = false;
      this.jackSpineAnimContainer.visible = false;
    }

    onLayoutComplete() {
      // somewhere to store the original positions
      // the mute button appears to be in the way AGAIN!!!
      // so the call was made to not reposition the numbers
      // this.lozBasegamePositions = [];

      for (let i = 0; i < this._maxLevel - 1; i++) {
        // dont include last element
        const name = `pos${i}Loz`;
        this[name] = resourceManager.get(
          `bgTrail:BGTrailContainer:Beanstalk_PositionCorrection_Container:Beanstalk_Panel_0${i + 1}`
        );
        this._lozOn[i] = this[name];
        // we need landscape and portrait coords
        // by the platform
        // coords at this point should be the same regardless of layout
        this._lozLandscapeCoords[i] = { x: this._lozOn[i].x, y: this._lozOn[i].y };
        this._lozPortraitCoords[i] = { x: this._lozOn[i].x, y: this._lozOn[i].y };

        // this.lozBasegamePositions[i] = { x: this[name].x, y: this[name].y };
        const offName = `pos${i}LozOff`;
        this[offName] = resourceManager.get(
          `bgTrail:BGTrailContainer:Beanstalk_PositionCorrection_Container:Beanstalk_Panel_0${i + 1}_off`
        );
        this._lozOff[i] = this[offName];
      }

      // now we have the landscape coords, lets adjust if needed if golden bet
      // isnt allowed
      if (!gdk.getPlatformAllowsUpstake()) {
        this._lozLandscapeCoords[0].y = 445;
        this._lozLandscapeCoords[1].y = 315;
        this._lozLandscapeCoords[2].y = 185;
      }

      this.eggBurst = resourceManager.get(
        `bgTrail:BGTrailContainer:Beanstalk_PositionCorrection_Container:Egg_Burst_Container:Egg_Burst`
      );
      this.eggWobble = resourceManager.get(
        `bgTrail:BGTrailContainer:Beanstalk_PositionCorrection_Container:Egg_Wobble`
      );
      this.eggWobble.onComplete = () => {
        this._eggWobbleAnimPlaying = false;
      };
      this.eggGlow = resourceManager.get(`bgTrail:BGTrailContainer:Beanstalk_PositionCorrection_Container:Egg_Glow`);
      this.eggGlow.visible = false;
      this.eggShatter = resourceManager.get(
        `bgTrail:BGTrailContainer:Beanstalk_PositionCorrection_Container:Egg_Shatter`
      );
      this.eggShatter.visible = false;

      this.minTextScaleContainer = resourceManager.get(
        `bgTrail:BGTrailContainer:Beanstalk_PositionCorrection_Container:minTextScaleContainer`
      );
      this.minTextScaleContainer.visible = false;

      this.eggAwardTextScaleContainer = resourceManager.get(
        `bgTrail:BGTrailContainer:Beanstalk_PositionCorrection_Container:eggAwardTextScaleContainer`
      );
      this.eggAwardTextScaleContainer.scale.set(1 * this._eggAwardTextScaleContainerMasterScale);

      this.eggAwardText = resourceManager.get(
        `bgTrail:BGTrailContainer:Beanstalk_PositionCorrection_Container:eggAwardTextScaleContainer:eggAwardText`
      );
      this.eggAwardText.visible = false;
      this.eggAwardGoldText = resourceManager.get(
        `bgTrail:BGTrailContainer:Beanstalk_PositionCorrection_Container:eggAwardTextScaleContainer:eggAwardGoldText`
      );
      this.eggAwardGoldText.visible = false;
      this.eggSparks = resourceManager.get(
        `bgTrail:BGTrailContainer:Beanstalk_PositionCorrection_Container:Egg_Award_Sparks`
      );
      this.eggSparks.anchor.x = 0.5;
      this.eggSparks.anchor.y = 0.5;
      this.eggSparks.visible = false;

      this.eggAwardBonusSymbols = [];
      for (let i = 0; i < 5; i++) {
        const symbol = resourceManager.get(
          `bgTrail:BGTrailContainer:Beanstalk_PositionCorrection_Container:eggAwardBonusSymbolContainer:eggAwardBonusSymbol${i}`
        );
        symbol.visible = false;
        this.eggAwardBonusSymbols[i] = symbol;
        this._moveTweenInfos[i] = {};
        this._scaleTweenInfos[i] = {};
      }

      // these functions are here, because originally
      // jack was parented to this class / obj
      // since then, jack has been moved, so he appears over the big win anim
      this.jackSpineAnimContainer = resourceManager.get(`jacksSpineAnimContainer`);
      this.jackStatic = resourceManager.get(`jacksSpineAnimContainer:jackStatic`);
      this.jackSpineAnim = resourceManager.createObject('spine', 'JackSpineAnim', this.jackSpineAnimContainer, {
        name: 'JackSpineAnim',
        defaultAnimation: 'Idle',
      });
      this.jackSpineAnim.visible = false;
      this.jackSpineAnim.x = -30;
      this.jackSpineAnim.y = 380;
      this.jackSpineAnim.scale.set(0.5, 0.5);
      this.jackSpineAnim.spineObject.stateData.defaultMix = 0.1;

      this.createTweens();

      this.reset();

      this._layoutComplete = true;

      // just to make sure the loz coords are set up correctly
      this.onOrientationChange(systemData.isLandscape);

      // make sure your browser is at the correct size
      // 1280 x 720
      // need to figure out how to convert the coords into a proper local space
      // so we dont have to make sure the browser is the correct size
      // the stage and gameContainer dont scale or move, its all the other containers inside :( yuck
      // const parent = this[`pos${0}Loz`].parent;
      // const localPos = parent.toLocal({ x: 148, y: 219 });
      // localPos.x -= this[`pos${0}Loz`].width / 2;
      // localPos.y -= this[`pos${0}Loz`].height / 2;
    }

    onOrientationChange(isLandscape) {
      if (!this._layoutComplete) return;

      // any tweens currently moving
      // e.g. the move tween
      // we ideally need to tell this to finish immediately
      // this.positionStackedWild();
      if (this._moveTweenInfo.tween && this._moveTweenInfo.tween.isActive()) {
        // this should make the tween finish early
        this._moveTweenInfo.tween.progress(1);
      }
      if (this._scaleTweenInfo.tween && this._scaleTweenInfo.tween.isActive()) {
        // this should make the tween finish early
        this._scaleTweenInfo.tween.progress(1);
      }

      for (let i = 0; i < this._moveTweenInfos.length; i++) {
        if (this._moveTweenInfos[i].tween && this._moveTweenInfos[i].tween.isActive()) {
          // this should make the tween finish early
          this._moveTweenInfos[i].tween.progress(1);
        }
      }
      for (let i = 0; i < this._scaleTweenInfos.length; i++) {
        if (this._scaleTweenInfos[i].tween && this._scaleTweenInfos[i].tween.isActive()) {
          // this should make the tween finish early
          this._scaleTweenInfos[i].tween.progress(1);
        }
      }

      const coordsToUse = isLandscape ? this._lozLandscapeCoords : this._lozPortraitCoords;
      for (let i = 0; i < this._lozOn.length; i++) {
        this._lozOn[i].x = coordsToUse[i].x;
        this._lozOn[i].y = coordsToUse[i].y;
        this._lozOff[i].x = coordsToUse[i].x;
        this._lozOff[i].y = coordsToUse[i].y;
      }
    }

    createTweens() {
      const durations = [0.8, 0.7, 0.6, 0.5];
      for (let i = 0; i < this._maxLevel - 1; i++) {
        // dont include last element
        this[`pulsePos${i}LozTween`] = gsap.fromTo(
          this[`pos${i}Loz`],
          {
            alpha: 1,
          },
          {
            alpha: 0,
            repeat: -1,
            yoyo: true,
            duration: durations[i],
            delay: 0.5,
            ease: 'none',
            paused: true,
            immediateRender: false,
          }
        );
      }
      this.rotateEggBurstTween = gsap.fromTo(
        this.eggBurst,
        {
          rotation: 0,
        },
        {
          rotation: Math.PI * 2,
          repeat: -1,
          duration: 1,
          ease: 'none',
          paused: true,
          immediateRender: false,
        }
      );
    }

    async maskInGoldBeanstalk(durationInMS) {
      const goldBeanstalk = resourceManager.get('bgTrail:BGTrailContainer:BeanstalkGold');
      const beanstalk = resourceManager.get('bgTrail:BGTrailContainer:Beanstalk');
      const startHeight = 0;
      const startWidth = 0;
      const beanstalkHeight = goldBeanstalk.height; // as long as there are no children, this should be safe
      const beanstalkWidth = goldBeanstalk.width; // as long as there are no children, this should be safe

      const mask = new PIXI.Graphics();
      goldBeanstalk.mask = mask;
      goldBeanstalk.addChild(mask);

      let resolver = null;
      const promise = new Promise((resolve) => {
        resolver = resolve;
      });

      const tweenObj = {
        height: 0,
      };

      gsap.fromTo(
        tweenObj,
        {
          height: 0,
        },
        {
          height: beanstalkHeight,
          duration: durationInMS / 1000,
          onUpdate: () => {
            goldBeanstalk.visible = true;
            mask.clear();
            mask.beginFill(0x000000, 0);
            mask.drawRect(0, 0, beanstalkWidth, tweenObj.height);
            mask.endFill();
          },
          onComplete: () => {
            resolver();
          },
        }
      );

      await promise;

      goldBeanstalk.removeChild(mask);
      goldBeanstalk.mask = null;

      beanstalk.visible = false;
    }

    async maskOutGoldBeanstalk(durationInMS) {
      const goldBeanstalk = resourceManager.get('bgTrail:BGTrailContainer:BeanstalkGold');
      const beanstalk = resourceManager.get('bgTrail:BGTrailContainer:Beanstalk');
      const beanstalkHeight = goldBeanstalk.height; // as long as there are no children, this should be safe
      const beanstalkWidth = goldBeanstalk.width; // as long as there are no children, this should be safe

      const mask = new PIXI.Graphics();
      goldBeanstalk.mask = mask;
      goldBeanstalk.addChild(mask);

      let resolver = null;
      const promise = new Promise((resolve) => {
        resolver = resolve;
      });

      const tweenObj = {
        height: beanstalkHeight,
      };

      beanstalk.visible = true;

      gsap.fromTo(
        tweenObj,
        {
          height: beanstalkHeight,
        },
        {
          height: 0,
          duration: durationInMS / 1000,
          onUpdate: () => {
            goldBeanstalk.visible = true;
            mask.clear();
            mask.beginFill(0x000000, 0);
            mask.drawRect(0, 0, beanstalkWidth, tweenObj.height);
            mask.endFill();
          },
          onComplete: () => {
            resolver();
          },
        }
      );

      await promise;

      goldBeanstalk.removeChild(mask);
      goldBeanstalk.mask = null;

      goldBeanstalk.visible = false;
    }

    async fadeOffLozs() {
      const lozToFadeOff = [];
      for (let i = 0; i < this._maxLevel - 1; i++) {
        lozToFadeOff.push(this[`pos${i}Loz`]);
        lozToFadeOff.push(this[`pos${i}LozOff`]);
      }

      await game.tweenFromToAsync(
        lozToFadeOff,
        {
          alpha: 1,
        },
        {
          alpha: 0,
          duration: 0.5,
          ease: 'none',
        }
      );

      for (let i = 0; i < lozToFadeOff.length; i++) {
        lozToFadeOff[i].renderable = false;
        lozToFadeOff[i].alpha = 1;
      }
    }

    async fadeInLozs() {
      const lozToFadeOff = [];
      for (let i = 0; i < this._maxLevel - 1; i++) {
        lozToFadeOff.push(this[`pos${i}Loz`]);
        lozToFadeOff.push(this[`pos${i}LozOff`]);
      }

      for (let i = 0; i < lozToFadeOff.length; i++) {
        lozToFadeOff[i].renderable = true;
        lozToFadeOff[i].alpha = 0;
      }

      await game.tweenFromToAsync(
        lozToFadeOff,
        {
          alpha: 0,
        },
        {
          alpha: 1,
          duration: 0.5,
          ease: 'none',
        }
      );
    }

    respositionLozForFreeSpins() {
      // the mute button appears to be in the way AGAIN!!!
      // so the call was made to not reposition the numbers
      // for (let i = 0; i < this._maxLevel - 1; i++) {
      //   const loz = this[`pos${i}Loz`];
      //   loz.x = this.lozFreeSpinsPositions[i].x;
      //   loz.y = this.lozFreeSpinsPositions[i].y;
      //   const lozOff = this[`pos${i}LozOff`];
      //   lozOff.x = this.lozFreeSpinsPositions[i].x;
      //   lozOff.y = this.lozFreeSpinsPositions[i].y;
      // }
    }

    respositionLozForBaseGame() {
      // the mute button appears to be in the way AGAIN!!!
      // so the call was made to not reposition the numbers
      // for (let i = 0; i < this._maxLevel - 1; i++) {
      //   const loz = this[`pos${i}Loz`];
      //   loz.x = this.lozBasegamePositions[i].x;
      //   loz.y = this.lozBasegamePositions[i].y;
      //   const lozOff = this[`pos${i}LozOff`];
      //   lozOff.x = this.lozBasegamePositions[i].x;
      //   lozOff.y = this.lozBasegamePositions[i].y;
      // }
    }

    async incrementTrail(dontPulse = true) {
      this._incrementTrailFinished = false;

      if (this._currentLevel === this._maxLevel - 1) {
        // we are at the top already - nothing to do
      } else {
        if (this._currentLevel > -1) {
          // already moved along the trail
          this[`pulsePos${this._currentLevel}LozTween`].pause();
          this[`pos${this._currentLevel}Loz`].alpha = 1;
          this[`pos${this._currentLevel}LozOff`].visible = false;
        }

        this._currentLevel++;
        if (this._currentLevel === this._maxLevel - 1) {
          // just reached the top !!
          // this is where we do something with the spinny thing
          if (!freespins.inFreespins) {
            soundManager.play('bgEggGlow');
          }
          this.rotateEggBurstTween.time(0).restart(true);
          this.eggWobble.visible = false;
          this.eggGlow.visible = true;
          this.eggGlow.gotoAndPlay(0);
        } else {
          this._eggWobbleAnimPlaying = true;
          this.eggWobble.gotoAndPlay(0);
          this[`pos${this._currentLevel}Loz`].gotoAndPlay(0);
          if (dontPulse !== true) {
            this[`pos${this._currentLevel}LozOff`].visible = true;
            this[`pulsePos${this._currentLevel}LozTween`].time(0).restart(true);
          }
        }
      }

      this._incrementTrailFinished = true;
    }

    incrementTrailFinished() {
      return this._incrementTrailFinished;
    }

    hideTrail() {
      this.visible = false;
    }

    showTrail() {
      this.visible = true;
    }

    stopPulsing() {
      for (let i = 0; i < this._maxLevel - 1; i++) {
        this[`pos${i}LozOff`].visible = false;
        this[`pulsePos${i}LozTween`].pause();
        this[`pos${i}Loz`].alpha = 1;
      }
    }

    stopBurst() {
      this.rotateEggBurstTween.pause();
      this.eggBurst.rotation = 0;
      this.eggWobble.visible = true;
      this.eggGlow.gotoAndStop(0);
      this.eggGlow.visible = false;
    }

    reset() {
      // and tidy up anything else at the top
      this._eggMultiplierAwarded = false;
      this._eggFSAwarded = false;

      this._currentLevel = this._startingLevel;
      for (let i = 0; i < this._maxLevel - 1; i++) {
        this[`pos${i}Loz`].gotoAndStop(0);
        this[`pos${i}Loz`].alpha = 1;
        this[`pos${i}LozOff`].gotoAndStop(0);
        this[`pos${i}LozOff`].visible = false;
        this[`pulsePos${i}LozTween`].pause();
      }
      this.stopBurst();
    }

    async playEggShatterAnim() {
      let resolver = null;
      const promise = new Promise((resolve) => {
        resolver = resolve;
      });

      this.eggShatter.visible = true;
      this.eggShatter.gotoAndPlay(0);
      this.eggShatter.onComplete = () => {
        resolver();
      };

      await promise;

      // we need to keep this visible until the right time
      // we bring egg_glow back
      // this.eggShatter.visible = false;
    }

    async playEggSparksAnim() {
      let resolver = null;
      const promise = new Promise((resolve) => {
        resolver = resolve;
      });

      this.eggSparks.visible = true;
      this.eggSparks.gotoAndPlay(0);
      this.eggSparks.onComplete = () => {
        resolver();
      };

      await promise;

      this.eggSparks.visible = false;
    }

    setMinMultiplier(minMultiplier) {
      this._multiplier = minMultiplier;
      this._currentMinMultiplierLevel = this._minMultipliers.indexOf(this._multiplier);
      if (this._multiplier >= 20) {
        this.eggAwardText.visible = false;
        this.eggAwardGoldText.visible = true;
      } else {
        this.eggAwardText.visible = true;
        this.eggAwardGoldText.visible = false;
      }
      this.eggAwardText.setText(`${this._multiplier}x`);
      this.eggAwardGoldText.setText(`${this._multiplier}x`);
    }

    getMinMultiplier() {
      return this._multiplier;
    }

    async fadeInMinMultiplier() {
      this.minTextScaleContainer.visible = true;
      this.minTextScaleContainer.alpha = 0;

      if (this._multiplier >= 20) {
        this.eggAwardText.visible = false;
        this.eggAwardGoldText.visible = true;
      } else {
        this.eggAwardText.visible = true;
        this.eggAwardGoldText.visible = false;
      }

      this.eggAwardText.alpha = 0;
      this.eggAwardGoldText.alpha = 0;
      await game.tweenFromToAsync(
        [this.eggAwardText, this.eggAwardGoldText, this.minTextScaleContainer],
        {
          alpha: 0,
        },
        {
          alpha: 1,
          duration: 0.5,
        }
      );
    }

    async fadeOutMinMultiplier() {
      await game.tweenFromToAsync(
        [this.eggAwardText, this.eggAwardGoldText, this.minTextScaleContainer],
        {
          alpha: 1,
        },
        {
          alpha: 0,
          duration: 0.5,
        }
      );
      this.eggAwardText.visible = false;
      this.eggAwardGoldText.visible = false;
      this.minTextScaleContainer.visible = false;
    }

    incrementMinMultiplier() {
      this._currentMinMultiplierLevel++;
      this._multiplier = this._minMultipliers[this._currentMinMultiplierLevel];
      if (this._multiplier >= 20) {
        this.eggAwardText.visible = false;
        this.eggAwardGoldText.visible = true;
      } else {
        this.eggAwardText.visible = true;
        this.eggAwardGoldText.visible = false;
      }
      this.eggAwardText.setText(`${this._multiplier}x`);
      this.eggAwardGoldText.setText(`${this._multiplier}x`);
    }

    maxMinMultiplierReached() {
      let result = false;
      if (this._currentMinMultiplierLevel === this._minMultipliers.length - 1) {
        result = true;
      }
      return result;
    }

    async upgradeMinMultiplier() {
      if (!this.maxMinMultiplierReached()) {
        soundManager.play('fsEggUpgrade');
        soundManager.play('bgEggGlow');
        this._upgradeMinMultiplierFinished = false;
        const eggSparksPromise = this.playEggSparksAnim();
        await timerManager.delayAsync(250);

        this.incrementMinMultiplier();
        await game.tweenFromToAsync(
          this.eggAwardTextScaleContainer.scale,
          {
            x: 0,
            y: 0,
          },
          {
            x: 1 * this._eggAwardTextScaleContainerMasterScale,
            y: 1 * this._eggAwardTextScaleContainerMasterScale,
            duration: 0.25,
            ease: 'power1.out',
            onComplete: () => {},
          }
        );

        await eggSparksPromise;

        // now show a quick pop up to explain whats happened
        const minMultiplierPopup = resourceManager.get('minMultiplierPopupContainer:MinMultiplierPopup');
        await minMultiplierPopup.show(this._multiplier, this.timesUpgraded > 0);

        this.timesUpgraded++;

        this._upgradeMinMultiplierFinished = true;
      } else {
        // nothing to upgrade to
      }
    }

    async highlightMinMultiplier() {
      // briefly do something with the min multiplier
      let weStartedBurst = false;
      if (this.rotateEggBurstTween.isActive() !== true) {
        weStartedBurst = true;
        this.eggBurst.rotation = 0;
        this.rotateEggBurstTween.time(0).restart(true);
      }

      await game.tweenFromToAsync(
        this.eggAwardTextScaleContainer.scale,
        {
          x: 1 * this._eggAwardTextScaleContainerMasterScale,
          y: 1 * this._eggAwardTextScaleContainerMasterScale,
        },
        {
          x: 1.2 * this._eggAwardTextScaleContainerMasterScale,
          y: 1.2 * this._eggAwardTextScaleContainerMasterScale,
          duration: 0.5,
          ease: 'power1.inOut',
          yoyo: true,
          repeat: 3,
        }
      );

      if (weStartedBurst) {
        this.eggBurst.rotation = 0;
        this.rotateEggBurstTween.pause();
      }
    }

    upgradingMinMultiplierFinished() {
      return this._upgradeMinMultiplierFinished;
    }

    async revealMultiplier(multiplier) {
      soundManager.play('bgEggHatch');
      this._multiplierRevealed = false;

      this._multiplier = multiplier;

      this.eggAwardText.setText(`${this._multiplier}x`);
      this.eggAwardGoldText.setText(`${this._multiplier}x`);

      this.eggGlow.gotoAndStop(0);
      this.eggGlow.visible = false;

      const eggShatterPromise = this.playEggShatterAnim();

      // now wait 1 second before starting the scale tween
      await timerManager.delayAsync(1100);

      if (this._multiplier >= 20) {
        this.eggAwardText.visible = false;
        this.eggAwardGoldText.visible = true;
      } else {
        this.eggAwardText.visible = true;
        this.eggAwardGoldText.visible = false;
      }

      // now start scale tween
      this.eggAwardText.alpha = 1;
      this.eggAwardGoldText.alpha = 1;

      await game.tweenFromToAsync(
        this.eggAwardTextScaleContainer.scale,
        {
          x: 0,
          y: 0,
        },
        {
          x: 1 * this._eggAwardTextScaleContainerMasterScale,
          y: 1 * this._eggAwardTextScaleContainerMasterScale,
          duration: 0.5,
          ease: 'power1.out',
          onComplete: () => {},
        }
      );

      // scatter should of finished by now
      // but worth waiting just incase
      await eggShatterPromise;

      this._multiplierRevealed = true;
    }

    multiplierRevealed() {
      return this._multiplierRevealed;
    }

    async revealFS(data) {
      soundManager.play('bgEggHatch');

      this._fsRevealed = false;

      this.eggGlow.gotoAndStop(0);
      this.eggGlow.visible = false;

      const eggShatterPromise = this.playEggShatterAnim();

      // now wait 1 second before starting the scale tween
      await timerManager.delayAsync(1100);

      // now start scale tween
      // we need to scale in bonus symbol here
      this.eggAwardBonusSymbols[0].visible = true;
      this.eggAwardBonusSymbols[0].alpha = 1;
      this.eggAwardBonusSymbols[0].scale.set(0);

      await game.tweenFromToAsync(
        this.eggAwardBonusSymbols[0].scale,
        {
          x: 0,
          y: 0,
        },
        {
          x: 0.9,
          y: 0.9,
          duration: 0.25,
          ease: 'power1.out',
          onComplete: () => {},
        }
      );

      // scatter should of finished by now
      // but worth waiting just incase
      await eggShatterPromise;

      this._fsRevealed = true;
    }

    fsRevealed() {
      return this._fsRevealed;
    }

    async awardEggMultiplier() {
      this._eggMultiplierAwarded = false;

      const origParent = this.eggAwardTextScaleContainer.parent;
      const eggAwardTextChildIndex = origParent.getChildIndex(this.eggAwardTextScaleContainer);
      const origX = this.eggAwardTextScaleContainer.x;
      const origY = this.eggAwardTextScaleContainer.y;
      const stage = systemData.stage;
      const winningsTextContainer = resourceManager.get('winningsText:winningsTextContainer');
      const winningsText = resourceManager.get('winningsText:winningsTextContainer:winningsText');
      const newPosForText = winningsTextContainer.toLocal(this.eggAwardTextScaleContainer.toGlobal(stage));
      winningsTextContainer.addChild(this.eggAwardTextScaleContainer);
      this.eggAwardTextScaleContainer.x = newPosForText.x;
      this.eggAwardTextScaleContainer.y = newPosForText.y;

      soundManager.play('trailMoveMultiplierToWin');

      await Promise.all([
        game.tweenFromToAsync(
          this.eggAwardTextScaleContainer,
          {
            x: this.eggAwardTextScaleContainer.x,
            y: this.eggAwardTextScaleContainer.y,
          },
          {
            x: winningsText.x,
            y: winningsText.y,
            duration: 0.8,
            ease: 'power1.in',
          },
          this._moveTweenInfo
        ),
        game.tweenFromToAsync(
          this.eggAwardTextScaleContainer.scale,
          {
            x: 1 * this._eggAwardTextScaleContainerMasterScale,
            y: 1 * this._eggAwardTextScaleContainerMasterScale,
          },
          {
            x: 1.5 * this._eggAwardTextScaleContainerMasterScale,
            y: 1.5 * this._eggAwardTextScaleContainerMasterScale,
            duration: 0.8,
            ease: 'power1.in',
          },
          this._scaleTweenInfo
        ),
      ]);

      this.eggAwardText.visible = false;
      this.eggAwardText.text = '';
      this.eggAwardGoldText.visible = false;
      this.eggAwardGoldText.text = '';
      this.eggAwardTextScaleContainer.scale.x = 1 * this._eggAwardTextScaleContainerMasterScale;
      this.eggAwardTextScaleContainer.scale.y = 1 * this._eggAwardTextScaleContainerMasterScale;
      this.eggAwardTextScaleContainer.x = origX;
      this.eggAwardTextScaleContainer.y = origY;
      origParent.addChildAt(this.eggAwardTextScaleContainer, eggAwardTextChildIndex);

      // we need to keep this visible until the right time
      // we bring egg_glow back
      this.playEggSparksAnim();
      this.eggShatter.visible = false;
      this.eggWobble.visible = true;
      this.eggGlow.visible = false;
      this.rotateEggBurstTween.pause();
      this.eggBurst.rotation = 0;

      this._eggMultiplierAwarded = true;
    }

    eggMultiplierAwarded() {
      return this._eggMultiplierAwarded;
    }

    async moveFSSymbolTo(index, delay, reelData) {
      const bonusID = resourceManager.getConfiguration().symbols['Bonus'].ID;
      const eggAwardFSContainer = resourceManager.get('slotContainer:eggAwardFSContainer');

      const bonusSymbol = this.eggAwardBonusSymbols[index];
      bonusSymbol.visible = true;
      bonusSymbol.scale.set(0.9);
      // take the symbol
      // add to new parent, work out new current coords and final coords
      const stage = systemData.stage;
      const pos = eggAwardFSContainer.toLocal(bonusSymbol.toGlobal(stage));
      bonusSymbol.origX = bonusSymbol.x;
      bonusSymbol.origY = bonusSymbol.y;
      bonusSymbol.origParent = bonusSymbol.parent;
      eggAwardFSContainer.addChild(bonusSymbol);
      bonusSymbol.x = pos.x;
      bonusSymbol.y = pos.y;

      // now for final coords
      // get the symbol on the reels
      const reel = reelManager.reels[reelData.reel];
      const symbol = reel.symbolSprites[reelData.row].symbol;

      // now for the final ones
      const finalPos = eggAwardFSContainer.toLocal(symbol.toGlobal(stage));

      await Promise.all([
        game.tweenFromToAsync(
          bonusSymbol,
          {
            x: bonusSymbol.x,
            y: bonusSymbol.y,
          },
          {
            x: finalPos.x,
            y: finalPos.y,
            delay: delay / 1000,
            duration: 0.8,
            ease: 'power1.out',
          },
          this._moveTweenInfos[index]
        ),
        game.tweenFromToAsync(
          bonusSymbol.scale,
          {
            x: 0.9,
            y: 0.9,
          },
          {
            x: 1,
            y: 1,
            delay: delay / 1000,
            duration: 0.8,
            ease: 'power1.out',
          },
          this._scaleTweenInfos[index]
        ),
      ]);

      reel.setSymbol(reelData.row, bonusID, null, null);
      reel.parentOversizedSymbolWhenStopped(reelData.row);

      bonusSymbol.origParent.addChild(bonusSymbol);
      bonusSymbol.visible = false;
      bonusSymbol.scale.set(0.9);
      bonusSymbol.x = bonusSymbol.origX;
      bonusSymbol.y = bonusSymbol.origY;
    }

    clearUpgradeCounter() {
      this.timesUpgraded = 0;
    }

    async awardEggFS(data) {
      this._eggFSAwarded = false;

      // data.positions contains the info where these are going to
      // [{reel:0, row: 0}],

      let delay = 250 * (data.positions.length - 1);

      soundManager.play('bonusWhoosh');

      const promises = [];
      for (let i = 0; i < data.positions.length; i++) {
        promises[i] = this.moveFSSymbolTo(i, delay, data.positions[i]);
        delay -= 250;
      }

      await Promise.all(promises);

      this.playEggSparksAnim();
      this.eggShatter.visible = false;
      this.eggWobble.visible = true;
      this.eggGlow.visible = false;
      this.rotateEggBurstTween.pause();
      this.eggBurst.rotation = 0;

      this._eggFSAwarded = true;
    }

    eggFSAwarded() {
      return this._eggFSAwarded;
    }

    playEggWobble() {
      if (this.eggWobble.visible && !this._eggWobbleAnimPlaying) {
        // console.log('playing egg wobble');
        this._eggWobbleAnimPlaying = true;
        this.eggWobble.gotoAndPlay(0);
      }
    }
  }

  create = function (json) {
    return new BGTrailContainer();
  };

  initialise = function (json, container, resources) {
    container.initialise();
  };

  getFilesRequired = function (json) {
    return ['', ''];
  };

  resourceManager.registerObjectType('BGTrailContainer', create, initialise, getFilesRequired);
})();
